import { PhotoSizeWarningAlert } from '@/components/app/photos/photo-size-warning-alert'
import { TextToImageWarningDialog } from '@/components/app/photos/text-to-image-warning-dialog'
import { ClikArtSizeWarningAlert } from '@/components/app/clikart/clikart-size-warning-alert'
import { ClikArtTextToImageWarningDialog } from '@/components/app/clikart/clikart-text-to-image-warning-dialog'

type WarningDialog = { open: boolean; onCancel: () => void; onContinue: () => void }

/**
 * The confirmations a photo or ClikArt drop can raise: the art is too small for its target (place it
 * in a new frame instead), or filling the target would replace its text.
 */
export function EditorWarningDialogs({
  photoSize,
  photoTextToImage,
  clikArtSize,
  clikArtTextToImage,
}: {
  photoSize: WarningDialog
  photoTextToImage: WarningDialog
  clikArtSize: WarningDialog
  clikArtTextToImage: WarningDialog
}) {
  return (
    <>
      <PhotoSizeWarningAlert
        open={photoSize.open}
        onCancel={photoSize.onCancel}
        onContinue={photoSize.onContinue}
      />

      <TextToImageWarningDialog
        open={photoTextToImage.open}
        onCancel={photoTextToImage.onCancel}
        onContinue={photoTextToImage.onContinue}
      />

      <ClikArtSizeWarningAlert
        open={clikArtSize.open}
        onCancel={clikArtSize.onCancel}
        onContinue={clikArtSize.onContinue}
      />

      <ClikArtTextToImageWarningDialog
        open={clikArtTextToImage.open}
        onCancel={clikArtTextToImage.onCancel}
        onContinue={clikArtTextToImage.onContinue}
      />
    </>
  )
}
